"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesClientImpl = void 0;
const sfp_types_1 = require("@jetseafoodas/sfp-types");
const HttpClientImpl_1 = require("./HttpClientImpl");
class CompaniesClientImpl extends HttpClientImpl_1.HttpClientImpl {
    constructor(options, prefix) {
        super(options);
        this.fetch = async () => {
            return this.get(`${this.prefix}`);
        };
        this.update = async (request) => {
            return this.put(`${this.prefix}`, request);
        };
        this.getDefaultLocation = (company) => {
            if (!company || !company.locations || company.locations.length === 0) {
                return undefined;
            }
            const defaultLocation = company.locations.find((loc) => (loc.type = sfp_types_1.LocationType.COMPANY_ADDRESS));
            const loc = defaultLocation ? defaultLocation : company.locations[0];
            return Object.assign(Object.assign({}, loc), { id: loc.locationId });
        };
        this.addOrUpdateLocation = async (request) => {
            return this.put(`${this.prefix}/locations`, request);
        };
        this.deleteLocation = async (locationId) => {
            return this.delete(`${this.prefix}/locations/${locationId}`);
        };
        this.prefix = `${prefix}/v1/company/company`;
    }
}
exports.CompaniesClientImpl = CompaniesClientImpl;
